// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.psi-date-input > .v-input__control > .v-input__slot {\n    box-shadow: var(--dateinput-box-shadow) !important;\n}\n", ""]);
// Exports
module.exports = exports;
